/** @format */

import React, { Fragment, useEffect, useState } from "react";
import TableForm from "./tableForm";
import { ToastContainer, toast } from "react-toastify";
import "../App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Link,
} from "react-router-dom";
import logo from "./logo/udes.png";

const FormApp8 = ({ reqID, empId, approveEvent }) => {
  const [requestData, setRequestData] = useState([]);
  const [itemsTableData, setItemsTableData] = useState([]);

  const handleRequestSelect = async (reqId) => {
    // get document data

    // get items table

    if (reqId !== null) {
      const response = await fetch("//localhost:5000/api/requests/" + reqId);
      const data = await response.json();
      console.log(data);
      setItemsTableData(data.itemsTableData);
      setRequestData(data.requestData);

      if (requestData.approvedBy1) {
        setApprovedBy1("Approuvé");
      } else {
        setApprovedBy1("Non-apprové");
      }

      if (requestData.approvedBy1) {
        setApprovedBy2("Approuvé");
      } else {
        setApprovedBy2("Non-apprové");
      }

      if (requestData.approvedBy1) {
        setApprovedBy3("Approuvé");
      } else {
        setApprovedBy3("Non-apprové");
      }

      if (requestData.approvedBy1) {
        setApprovedBy4("Approuvé");
      } else {
        setApprovedBy4("Non-apprové");
      }

      if (requestData.approvedBy1) {
        setApprovedBy5("Approuvé");
      } else {
        setApprovedBy5("Non-apprové");
      }
    }
  };

  const [approvers, setApprovers] = useState([]);
  const fetchAppro = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch("http://localhost:5000/api/approvers");
    const data = await response.json();

    setApprovers(data);
    // console.log(approvers);
  };

  const [docs, setDocs] = useState([]);
  const fetchDocs = async () => {
    // Fetch the Docs and their IDs from the database.
    const response = await fetch("http://localhost:5000/api/documents");
    const data = await response.json();

    setDocs(data);
    // console.log(docs);
  };

  // get requests approval records --------------------------------

  const [approvalRecords, setApprovalRecords] = useState([]);
  const fetchApprovalRecords = async () => {
    const response = await fetch("//localhost:5000/api/approval_records");
    const data = await response.json();
    setApprovalRecords(data);
  };

  //display the approval status of the document ------------------

  const [approvalRecordsCurrentReq, setApprovalRecordsCurrentReq] = useState(
    []
  );

  const getRecsCurrentReq = () => {
    let recordsList = [];
    for (let i = 0; i < approvalRecords.length; i++) {
      if (approvalRecords[i].req_id === reqID) {
        recordsList.push(approvalRecords[i]);
      }
    }
    setApprovalRecordsCurrentReq(recordsList);
  };

  // console.log(approvalRecordsCurrentReq);
  //---------------------------------------------------------------

  const displayApproverTitle = (appId) => {
    for (let i = 0; i < approvers.length; i++) {
      if (approvers[i].app_id == appId) {
        return approvers[i].app_title;
      }
    }
  };

  const [empList, setEmpList] = useState([]);
  const fetchEmpList = async () => {
    const response = await fetch("//localhost:5000/api/employees");
    const data = await response.json();
    setEmpList(data);
  };

  const displayEmpTitle = (id) => {
    for (let i = 0; i < empList.length; i++) {
      if (empList[i].emp_id === id) {
        return empList[i].emp_name;
      }
    }
  };

  const getTitlesList = () => {
    let titlesList = [];
    for (let i = 0; i < docs.length; i++) {
      if (docs[i].doc_type_id === requestData.doc_type) {
        titlesList.push(
          displayApproverTitle(docs[i].approver_1),
          displayApproverTitle(docs[i].approver_2),
          displayApproverTitle(docs[i].approver_3),
          displayApproverTitle(docs[i].approver_4),
          displayApproverTitle(docs[i].approver_5),
          displayApproverTitle(docs[i].approver_6),
          displayApproverTitle(docs[i].approver_7),
          displayApproverTitle(docs[i].approver_8)
        );
      }
    }
    return titlesList.filter((titles) => titles != null);
  };

  const approversTitlesList = getTitlesList();

  function ApproDisplay({ approversTitlesList, reqAppRecList }) {
    const numberOfTitles = approversTitlesList.length;

    const layoutClass =
      numberOfTitles <= 1
        ? "appro-disp-single"
        : numberOfTitles === 2
        ? "appro-disp-double"
        : "appro-disp-multiple";

    return (
      <div className={layoutClass}>
        {approversTitlesList.map((title, index) => {
          const filteredRec = reqAppRecList.find(
            (record) => record.app_title === title
          );
          const approverName = filteredRec?.emp_name;

          return (
            <div key={index} className={`appro-disp-${index + 1}`}>
              <p className='appro-title'>{title}</p>
              {approverName && (
                <p className='appro-name'>Approuvé par Mr. {approverName}</p>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  useEffect(() => {
    fetchApprovalRecords();
    getRecsCurrentReq();
  }, [approvalRecords.length, reqID, approveEvent]);

  useEffect(() => {
    handleRequestSelect(reqID);
    fetchDocs();
    fetchAppro();
    fetchEmpList();
  }, []);

  useEffect(() => {
    handleRequestSelect(reqID);
  }, [reqID]);

  const [approvedBy1, setApprovedBy1] = useState(null);
  const [approvedBy2, setApprovedBy2] = useState(null);
  const [approvedBy3, setApprovedBy3] = useState(null);
  const [approvedBy4, setApprovedBy4] = useState(null);
  const [approvedBy5, setApprovedBy5] = useState(null);

  return (
    <div className='document-page'>
      <div className='doc-heading'>
        <div className='doc-heading-top'>
          <div className='doc-ht-ar'>
            الجمهورية الجزائرية الديمقراطية الشعبية
          </div>
          <div className='doc-ht-fr'>
            République Algérienne Démocratique et Populaire
          </div>
          <div className='doc-ht-ar'>وزارة التعليم العالي و البحث العلمي</div>
          <div className='doc-ht-fr'>
            Ministère de l'Enseignement Supérieur et de la Recherche
            Scientifique
          </div>
        </div>
        <div className='doc-heading-line'></div>
        <div className='doc-heading-bottom'>
          <div className='doc-hb-left'>
            <span className='doc-hb-uplef-text'>EPST/CDER</span>
            <span className='doc-hb-bottlef-text'>
              UNITE DE DEVELOPEMENT DES EQUIPEMENTS SOLAIRES
            </span>
          </div>
          <div className='doc-heading-logo'>
            <img src={logo} alt='logo' />
          </div>

          <div className='doc-hb-right'>
            <span className='doc-hb-upright-text'>م.ع.ط.ع.ت./م.ط.ت.م</span>
            <span className='doc-hb-bottright-text'>
              وحدة تنمية الاجهزة الشمسية
            </span>
          </div>
        </div>
        <div className='doc-heading-line'></div>
      </div>

      <div className='doc-body-top'>
        <div className='doc-top-info'>
          <span className='label'>N°:</span>
          <span className='value'>{requestData.ref_field}</span>
        </div>
        <div className='doc-top-info'>
          <span className='label'>Bou-ismail, le:</span>
          <span className='value'>
            {new Date(requestData.req_date).toLocaleDateString("en-GB")}
          </span>
        </div>
      </div>

      <div className='doc-body-middle'>
        <div className='doc-body-title'>
          <h5>DEMANDE DE TRAVAUX PROJET DE RECHERCHE</h5>
        </div>
        <div className='doc-body-mid-info'>
          <div className='info'>
            <span className=''>Equipe/Division:</span>
            <span className='value'>{requestData.dep_name}</span>
          </div>

          <div className='info'>
            <span className=''>Projet:</span>
            <span className='value'>{requestData.project}</span>
          </div>

          <div className='info'>
            <span className=''>Chef de projet:</span>
            <span className='value'>
              {displayEmpTitle(requestData.project_head)}
            </span>
          </div>

          <div className='info'>
            <span className=''>Chargé de suivi des travaux:</span>
            <span className='value'>
              {displayEmpTitle(requestData.project_supervisor)}
            </span>
          </div>

          <div className='info-checkbox-container'>
            <div className='info-checkbox'>
              <span className=''>Type des travaux:</span>

              <label className='checkB'>
                <input
                  className='checkbox-output'
                  type='checkbox'
                  checked={requestData.new_realisation}
                />
                Nouvelle réqlisation
              </label>
              <label className='checkB'>
                <input
                  className='checkbox-output'
                  type='checkbox'
                  checked={requestData.renovation}
                />
                Rénovation
              </label>
              <label className='checkB'>
                <input
                  className='checkbox-output'
                  type='checkbox'
                  checked={requestData.maintenance}
                />
                Maintenance
              </label>
            </div>

            <div className='info-checkbox'>
              <span className=''>Nature de travaux:</span>

              <label className='checkB'>
                <input
                  className='checkbox-output'
                  type='checkbox'
                  checked={requestData.mecanique}
                />
                Mécanique
              </label>
              <label className='checkB'>
                <input
                  className='checkbox-output'
                  type='checkbox'
                  checked={requestData.electronique}
                />
                Electronique
              </label>
              <label className='checkB'>
                <input
                  className='checkbox-output'
                  type='checkbox'
                  checked={requestData.amenagement_electrique}
                />
                Aménagement/électrique
              </label>
            </div>
          </div>

          <div class='doc-description'>
            <label class='doc-description-label' for='doc-discription'>
              Travaux à réaliser (Précision):
            </label>
            <span id='doc-description'>{requestData.work_description}</span>
          </div>
        </div>
      </div>

      <div className='info-checkbox-container'>
        <div className='info-checkbox2'>
          <span className='inf-checkbox2-label'>
            Achat matériel / Fourniture:
          </span>

          <label className='checkB'>
            <input
              className='checkbox-output'
              type='checkbox'
              checked={requestData.materials_acquisition}
            />
            Oui
          </label>
          <label className='checkB'>
            <input
              className='checkbox-output'
              type='checkbox'
              checked={!requestData.materials_acquisition}
            />
            Non
          </label>
        </div>

        <div className='info-checkbox2'>
          <span className='inf-checkbox2-label'>Prestation externe:</span>

          <label className='checkB'>
            <input
              className='checkbox-output'
              type='checkbox'
              checked={requestData.external_service}
            />
            Oui
          </label>
          <label className='checkB'>
            <input
              className='checkbox-output'
              type='checkbox'
              checked={!requestData.external_service}
            />
            Non
          </label>
        </div>
      </div>

      <div className='doc-body-bottom'>
        <div id='doc-approvers' className='doc-approvers'>
          <ApproDisplay
            approversTitlesList={approversTitlesList}
            reqAppRecList={approvalRecordsCurrentReq}
          />
        </div>
      </div>

      <div className='doc-footer'>
        <div className='doc-footer-separator'></div>
        <span className='doc-footer-text'>
          UDES, Route Nationale N°11, BP386, Bou-Ismail, 42415, Wilaya de Tipaza
          Tel. / Fax : 024221408, Site Web :udes.cder.dz
        </span>
      </div>
    </div>
  );
};

export default FormApp8;
